// store.js
import { createStore } from 'redux';

// Initial State
const initialState = {
  personalDetails: {},
  familyDetails:{}
};

// Action Types
const SET_PERSONAL_DETAILS = 'SET_PERSONAL_DETAILS';
const SET_FAMILY_DETAILS='SET_FAMILY_DETAILS';

// Action Creator
export const setPersonalDetails = (details) => ({
  type: SET_PERSONAL_DETAILS,
  payload: details,
});
export const setFamilyDetails=(details)=>({
    type:SET_FAMILY_DETAILS,
    payload:details,
})

// Reducer
function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PERSONAL_DETAILS:
      return {
        ...state,
        personalDetails: action.payload,
      };
    case SET_FAMILY_DETAILS:
        return{
            ...state,
            familyDetails:action.payload,
        }
    default:
      return state;
  }
}

// Create Store
const store = createStore(rootReducer);

export default store;
